import client from 'core/axios';
import RequestMethod from 'core/axios/RequestMethod';
import { handleJSONResponse } from 'core/axios/handleResponse';
import handleError from 'core/axios/handleError';

export const getSkillGroups = ({ version = 'v3' } = {}) =>
  client
    .request({
      url: `${version}/skills-assessment/skill-groups/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSkills = ({ version = 'v3' } = {}) =>
  client
    .request({
      url: `${version}/skills-assessment/skills/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAbilities = ({ version = 'v3' } = {}) =>
  client
    .request({
      url: `${version}/skills-assessment/abilities/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getResultList = ({ version = 'v3', params } = {}) =>
  client
    .request({
      url: `${version}/skills-assessment/results/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const submitResult = ({ payload, version = 'v3' } = {}) =>
  client
    .request({
      url: `${version}/skills-assessment/results/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getResult = ({ version = 'v3', resultId } = {}) =>
  client
    .request({
      url: `${version}/skills-assessment/results/${resultId}`,
      resultId,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);
